import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { InstagramIcon, MenuIcon, XIcon } from 'lucide-react';
const NAV_ITEMS = [{
  label: 'Home',
  href: '#home'
}, {
  label: 'Services',
  href: '#services'
}, {
  label: 'Pricing',
  href: '#pricing'
}, {
  label: 'About',
  href: '#about'
}, {
  label: 'FAQ',
  href: '#faq'
}];
export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  const handleAnchorNavigation = (event: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    event.preventDefault();
    setOpen(false);
    const target = document.querySelector(href);
    if (!target) return;
    window.history.pushState(null, '', href);
    target.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  };
  return <header className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white/90 backdrop-blur-md border-b border-slate-100 shadow-[0_1px_20px_rgba(15,23,42,0.05)]' : 'bg-transparent'}`} data-id="element-136" data-mp="elzncvnm74rl">
      <nav className="mx-auto max-w-7xl px-5 sm:px-8 h-20 flex items-center justify-between" data-id="element-137" data-mp="oje1uppz9jh9">
        <a href="#home" onClick={event => handleAnchorNavigation(event, '#home')} className="group flex items-center" aria-label="Ally Cleaning Services — Inicio" data-id="element-138" data-mp="3n19ljsodvpu3">
          <img src="https://cdn.magicpatterns.com/uploads/qJ4YaQAYSmEGT7DVd9MzLA/Logo_Ally_C.png" alt="Logo circular de Ally Cleaning Services" className="h-14 w-14 rounded-full object-contain transition-transform duration-300 group-hover:scale-[1.02]" data-id="element-139" data-mp="5mw15it5i98v" />
        </a>

        <ul className="hidden md:flex items-center gap-9" data-id="element-140" data-mp="31arouu9nrbhx">
          {NAV_ITEMS.map(item => <li key={item.label} data-id="element-141" data-mp="2wcq6kbk23g7i">
              <a href={item.href} onClick={event => handleAnchorNavigation(event, item.href)} className="text-sm font-medium text-slate-soft hover:text-magenta transition-colors relative after:absolute after:-bottom-1.5 after:left-0 after:h-px after:w-0 after:bg-magenta hover:after:w-full after:transition-all after:duration-300" data-id="element-142" data-mp="2wbf3yf2ckehz">
                {item.label}
              </a>
            </li>)}
        </ul>

        <div className="hidden md:flex items-center gap-3" data-id="element-143" data-mp="2sbmqbny3ji5r">
          <a href="https://www.instagram.com/ally.cleaningservices" target="_blank" rel="noreferrer" aria-label="Visit Ally Cleaning Services on Instagram" className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-slate-200 text-slate-soft transition-colors hover:border-magenta hover:text-magenta focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-magenta" data-id="element-144" data-mp="2nbia7z13opg2">
            <InstagramIcon className="h-4 w-4" aria-hidden="true" data-id="element-145" data-mp="f1sivx15dnv7" />
          </a>
          <a href="sms:+19296509940" className="inline-flex items-center justify-center rounded-full bg-magenta px-6 py-2.5 text-sm font-semibold text-white shadow-lg shadow-magenta/25 hover:bg-magenta-dark hover:shadow-magenta/30 transition-all" data-id="element-146" data-mp="15ouwlgvabr6">
            Book Now
          </a>
        </div>

        <div className="flex items-center gap-2 md:hidden" data-id="element-147" data-mp="xw7jfr33xol5">
          <a href="sms:+19296509940" className="inline-flex items-center justify-center rounded-full bg-magenta px-4 py-2.5 text-xs font-semibold text-white shadow-lg shadow-magenta/25 transition-colors hover:bg-magenta-dark focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-magenta focus-visible:ring-offset-2" data-id="element-148" data-mp="k26q5cuxcts6">
            Book Now
          </a>
          <button type="button" onClick={() => setOpen(v => !v)} aria-label={open ? 'Close menu' : 'Open menu'} aria-expanded={open} className="inline-flex h-10 w-10 items-center justify-center rounded-full text-slate hover:bg-slate-100 transition-colors" data-id="element-149" data-mp="3p3i8ixkiof93">
            {open ? <XIcon className="h-5 w-5" data-id="element-150" data-mp="bmra87938br2" /> : <MenuIcon className="h-5 w-5" data-id="element-151" data-mp="bm98ww7kj7ca" />}
          </button>
        </div>
      </nav>

      <AnimatePresence data-id="element-152" data-mp="6q0whqkr9s8t">
        {open && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} transition={{
        duration: 0.25
      }} className="md:hidden overflow-hidden bg-white border-b border-slate-100" data-id="element-153" data-mp="1wpp9oc179gd">
            <ul className="px-5 py-4 space-y-1" data-id="element-154" data-mp="28bmpeb4b22yb">
              {NAV_ITEMS.map(item => <li key={item.label} data-id="element-155" data-mp="2dar0j7asiara">
                  <a href={item.href} onClick={event => handleAnchorNavigation(event, item.href)} className="block rounded-lg px-3 py-3 text-base font-medium text-slate-soft hover:bg-slate-50 hover:text-magenta transition-colors" data-id="element-156" data-mp="2h9qf7jmbplvx">
                    {item.label}
                  </a>
                </li>)}
              <li className="pt-2" data-id="element-157" data-mp="30xpg82r35eo5">
                <a href="sms:+19296509940" onClick={() => setOpen(false)} className="block rounded-full bg-magenta px-6 py-3 text-center text-sm font-semibold text-white" data-id="element-158" data-mp="30yr0mxtzrdij">
                  Book Now
                </a>
              </li>
            </ul>
          </motion.div>}
      </AnimatePresence>
    </header>;
}